export const ValidationWorkFlowAction = {
    path: '/validation_work_flow_actions',
    name: 'validation_work_flow_actions',
    component: () => import('@/views/Request/ValidationWorkFlowAction/ValidationWorkFlowActionPage.vue'),
    children: [
        {
            path: '/validation_work_flow_actions/view/:id',
            name: 'validation_work_flow_actions.view',
            component: () => import('@/views/Request/ValidationWorkFlowAction/Form/ValidationWorkFlowActionView.vue'),
        },
        {
            path: '/validation_work_flow_actions/set_validation_work_flow',
            name: 'validation_work_flow_actions.set_validation_work_flow',
            component: () => import('@/views/Worker/Form/SetValidationWorkFlowForm.vue'),
        },
        {
            path: '/validation_work_flow_actions/set_validation_work_flow/:actionId',
            name: 'validation_work_flow_actions.set_validation_work_flow.action',
            component: () => import('@/views/Worker/Form/SetValidationWorkFlowForm.vue'),
        },
    ],
}